import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDataModelReportsState from './dataModelReports';
import updateDictionaryReportsState from './dictionaryReports';

const handlers = {
  ...updateDataModelReportsState,
  ...updateDictionaryReportsState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
